// @format
import React from 'react';
import { compose, withStateHandlers, withProps } from 'recompose';
import { omitProps } from 'modules/hocs/utils';
import { applySpec, prop } from 'ramda';

const initialVisible = {
  isVisible: false,
  setVisible: () => {},
};

const DownloadBtnVisibleContext = React.createContext(initialVisible);

const Provider = compose(
  withStateHandlers(
    {
      isVisible: false,
    },
    {
      setVisible: () => value => ({ isVisible: value }),
    },
  ),
  withProps(
    applySpec({
      value: {
        isVisible: prop('isVisible'),
        setVisible: prop('setVisible'),
      },
    }),
  ),
  omitProps(['isVisible', 'setVisible']),
)(DownloadBtnVisibleContext.Provider);

export default { Provider, Consumer: DownloadBtnVisibleContext.Consumer };



// WEBPACK FOOTER //
// ./src/modules/context/DownloadBtnVisibleContext.js